import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileStickyBar } from './MobileStickyBar';
import { TopStrip } from './TopStrip';
import { useLocation } from 'react-router-dom';
import { BUSINESS_NAME, WEBSITE_URL, PHONE, ADDRESS_LINE_1, ADDRESS_LINE_2, FACEBOOK_URL } from '../constants/business';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'SportingGoodsStore',
    name: BUSINESS_NAME,
    url: WEBSITE_URL,
    telephone: PHONE,
    address: {
      '@type': 'PostalAddress',
      streetAddress: ADDRESS_LINE_1,
      addressLocality: 'Lake Benton',
      addressRegion: 'MN',
      postalCode: '56149',
      addressCountry: 'US'
    },
    sameAs: [FACEBOOK_URL]
  };
  return <div className="min-h-screen bg-brand-offwhite flex flex-col" data-id="element-126">
      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} data-id="element-127" />
      <TopStrip data-id="element-128" />
      <Header data-id="element-129" />
      <main className="flex-grow" data-id="element-130">{children}</main>
      <Footer data-id="element-131" />
      <MobileStickyBar data-id="element-132" />
    </div>;
}